import TimeSince from "./Time";

export default TimeSince